/* Native product POST + Shopify return_to. Dawn continues handling Add to Cart. */
if (!window.v5PdpCheckoutBound) {
 window.v5PdpCheckoutBound = true;
 document.addEventListener('submit', (event) => {
  if (!event.submitter?.matches('.v5-pdp .v5-buy-now')) return;
  const form = event.target;
  const product = form.closest('product-info');
  const add = form.querySelector('[name="add"]');
  const quantity = product?.querySelector('input[name="quantity"]');
  if (!add || add.disabled || add.getAttribute('aria-disabled') === 'true' || !quantity?.reportValidity()) {
   event.preventDefault();
  }
  // Let the browser submit the native form with the clicked return_to button.
  event.stopImmediatePropagation();
 }, true);
 const sync = () => document.querySelectorAll('.v5-pdp product-form').forEach(el => {
  const add = el.querySelector('[name="add"]'), buy = el.querySelector('.v5-buy-now');
  if (add && buy) { const disabled = add.disabled || add.getAttribute('aria-disabled') === 'true'; if (buy.disabled !== disabled) buy.disabled = disabled; }
 });
 const observer = new MutationObserver(sync);
 document.querySelectorAll('.v5-pdp').forEach(el => observer.observe(el, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']}));
 sync();
}

// Gallery navigation uses Dawn's existing active-media API.
if (!customElements.get('v5-gallery-controls')) {
 customElements.define('v5-gallery-controls', class extends HTMLElement {
  connectedCallback() {
   this.gallery = this.closest('media-gallery');
   this.viewer = this.gallery?.querySelector('[id^="Slider-Gallery-"]');
   if (!this.viewer) return;
   this.abort = new AbortController();
   const signal = this.abort.signal;
   this.update = () => {
    const media = [...this.viewer.querySelectorAll('.product__media-item')];
    const current = Math.max(0,media.findIndex(item=>item.classList.contains('is-active')));
    const label = `${current+1} / ${media.length}`;
    const counter = this.querySelector('[data-gallery-position]');
    if(counter.textContent!==label) counter.textContent=label;
    this.hidden=media.length<2;
   };
   this.viewer.addEventListener('touchstart',e=>{
    const active=this.viewer.querySelector('.is-active');
    this.start=e.touches.length===1&&active?.querySelector('img')&&!active.querySelector('deferred-media,model-viewer')?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;
   },{passive:true,signal});
   this.viewer.addEventListener('touchmove',e=>{
    if(e.touches.length!==1){this.start=null;return;}
    if(!this.start)return;
    const dx=e.touches[0].clientX-this.start.x,dy=e.touches[0].clientY-this.start.y;
    if(Math.abs(dx)>20&&Math.abs(dx)>Math.abs(dy)*1.5&&e.cancelable)e.preventDefault();
   },{passive:false,signal});
   this.viewer.addEventListener('touchend',e=>{
    if(!this.start||!e.changedTouches.length)return;
    const dx=e.changedTouches[0].clientX-this.start.x,dy=e.changedTouches[0].clientY-this.start.y;
    this.start=null;
    if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.5)return;
    const media=[...this.viewer.querySelectorAll('.product__media-item')];
    if(media.length<2||typeof this.gallery.setActiveMedia!=='function')return;
    const current=Math.max(0,media.findIndex(item=>item.classList.contains('is-active')));
    this.suppressClickUntil=Date.now()+500;
    this.gallery.setActiveMedia(media[(current+(dx<0?1:-1)+media.length)%media.length].dataset.mediaId,false);
   },{passive:true,signal});
   this.viewer.addEventListener('touchcancel',()=>{this.start=null;},{signal});
   this.viewer.addEventListener('click',e=>{if(Date.now()<(this.suppressClickUntil||0)){e.preventDefault();e.stopImmediatePropagation();}},{capture:true,signal});
   this.observer=new MutationObserver(this.update);
   this.observer.observe(this.viewer,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
   this.gallery.classList.add('v5-gallery-enhanced');
   this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.gallery?.classList.remove('v5-gallery-enhanced');}
 });
}
if (!window.v5UniversalGalleryBound) {
 window.v5UniversalGalleryBound = true;
 document.addEventListener('click', event => {
  const button = event.target.closest('[data-v5-gallery-step]');
  if (!button) return;
  const gallery = button.closest('media-gallery');
  const media = [...gallery.querySelectorAll('.product__media-item')];
  if (!media.length) return;
  const current = media.findIndex(item => item.classList.contains('is-active'));
  const index = (current + Number(button.dataset.v5GalleryStep) + media.length) % media.length;
  gallery.setActiveMedia(media[index].dataset.mediaId, false);
 });
}
// Existing description content is formatted, never rewritten or saved to Shopify.
// Embedded images are placed in the top gallery automatically, so no SKU setup is needed.
if (!customElements.get('v5-product-description')) {
 customElements.define('v5-product-description', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.ready) return;
   const template = this.querySelector('template');
   const body = this.querySelector('.v5-description-body');
   if (!template || !body) return;
   this.dataset.ready = 'true';
   const fragment = template.content.cloneNode(true);
   const urls = [...fragment.querySelectorAll('img')].map(image => ({src:image.getAttribute('src') || image.getAttribute('data-src'),alt:image.getAttribute('alt') || 'From product description'})).filter(image => {
    try { return ['http:','https:'].includes(new URL(image.src, location.origin).protocol); } catch { return false; }
   });
   fragment.querySelectorAll('script,style,img,picture,source,video,iframe,object,embed,form,button,svg').forEach(node => node.remove());
   const allowed = new Set(['P','DIV','SPAN','STRONG','EM','B','I','U','UL','OL','LI','H1','H2','H3','H4','H5','H6','TABLE','THEAD','TBODY','TFOOT','TR','TD','TH','BR','HR','A','BLOCKQUOTE','SUP','SUB']);
   for (const node of [...fragment.querySelectorAll('*')]) {
    if (!allowed.has(node.tagName)) { node.replaceWith(...node.childNodes); continue; }
    for (const attr of [...node.attributes]) {
     if (node.tagName === 'A' && attr.name === 'href' && /^(https?:|mailto:|tel:|\/|#)/i.test(attr.value)) continue;
     if (['TD','TH'].includes(node.tagName) && ['colspan','rowspan'].includes(attr.name) && /^\d+$/.test(attr.value)) continue;
     node.removeAttribute(attr.name);
    }
   }
   body.replaceChildren(fragment);
   this.moveImagesToGallery(urls);
  }
  moveImagesToGallery(images) {
   const product = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
   const gallery = product?.querySelector('media-gallery');
   if (!gallery || !images.length) return;
   const key = src => { try { return new URL(src,location.origin).pathname.split('/').pop(); } catch { return src; } };
   const existing = new Set([...gallery.querySelectorAll('img')].map(image => key(image.src)));
   const unique = images.filter(image => {const name=key(image.src);if(existing.has(name))return false;existing.add(name);return true;});
   const append = () => {
    const viewer = gallery.querySelector('[id^="Slider-Gallery-"]');
    const thumbs = gallery.querySelector('[id^="Slider-Thumbnails-"]');
    if (!viewer) return;
    unique.forEach((image,index) => {
     const id = `${product.dataset.section}-description-${index}`;
     if (viewer.querySelector(`[data-media-id="${id}"]`)) return;
     const item=document.createElement('li');item.id=`Slide-${id}`;item.dataset.mediaId=id;item.className='product__media-item grid__item slider__slide';
     const frame=document.createElement('div');frame.className='v5-description-gallery-image';
     const link=document.createElement('a');link.href=image.src;link.target='_blank';link.rel='noopener';link.className='v5-description-image-link';link.setAttribute('aria-label','Open original description image');
     const img=document.createElement('img');img.src=image.src;img.alt=image.alt;img.loading='lazy';img.decoding='async';link.append(img);frame.append(link);item.append(frame);viewer.append(item);
     if (thumbs && !thumbs.querySelector(`[data-target="${id}"]`)) {
      const thumb=document.createElement('li');thumb.className='thumbnail-list__item slider__slide';thumb.dataset.target=id;thumb.dataset.mediaPosition=viewer.children.length;
      const button=document.createElement('button');button.type='button';button.className='thumbnail global-media-settings global-media-settings--no-shadow';button.setAttribute('aria-label',`Show description image ${index+1}`);button.setAttribute('aria-controls',viewer.id);
      const preview=document.createElement('img');preview.src=image.src;preview.alt=image.alt;preview.loading='lazy';button.append(preview);button.addEventListener('click',()=>gallery.setActiveMedia(id,false));thumb.append(button);thumbs.append(thumb);
     }
    });
    gallery.querySelector('.v5-gallery-nav').hidden=viewer.children.length<2;
    gallery.querySelectorAll('slider-component').forEach(slider=>slider.resetPages?.());
   };
   append();
   // Dawn refreshes the gallery when a variant changes; restore description media once.
   const observer=new MutationObserver(append);observer.observe(gallery.querySelector('[id^="Slider-Gallery-"]'),{childList:true});
   this.galleryObserver=observer;
  }
  disconnectedCallback(){this.galleryObserver?.disconnect();}
 });
}

